import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { DELETE_NOTIFICATIONS_ACTIONTYPE, GET_ALL_NOTIFICATIONS_ACTIONTYPE, MARK_NOTIFICATIONS_ACK_ACTIONTYPE } from './actionTypes';
import { getPreviousQueryTimeSelector } from './selectors';
import { API_ENDPOINTS, buildURL, httpRequest, parseDataObj, SnackbarHandlerSchema } from '../../utils';
import { acknowledgeNotificationAction, deleteNotificationAction, getAllNotificationsAction } from './actions';
import { SNACKBAR_VARIANTS } from '../../utils/constants';
import { publishErrorAction } from '../../appContainer/actions';
import { getNDaysPriorStartTime } from '../../utils/DateUtils';
import SoundManager from '../../utils/SoundManager';
import { notificationSoundSettingSelector } from '../../appContainer/selectors';

const soundManager = new SoundManager();

function* playSoundForTime(sound, times) {
  for (let i = 0; i < times; i++) {
    sound.play();
    yield delay(1000);
  }
}

function* triggerAlarmSounds(newNotifications) {
  const isSoundAllowed = yield select(notificationSoundSettingSelector);

  if (!isSoundAllowed) {
    return;
  }

  const safeNotifs = Array.isArray(newNotifications) ? [...newNotifications] : [];

  const unackNotif = safeNotifs.filter(notif => !notif.acknowledged);
  const alarms = unackNotif.filter(notif => notif.type === 'ALARM');
  const notifications = unackNotif.filter(notif => notif.type === 'NOTIFICATION');

  if (alarms.length) {
    yield call(playSoundForTime, soundManager.getAlarmSound(), 3);
  } else if (notifications.length) {
    yield call(playSoundForTime, soundManager.getNotificationSound(), 1);
  }
}

function* getAllNotificationForUser() {
  yield put(getAllNotificationsAction.Loading(true));
  let timeInMillis = yield select(getPreviousQueryTimeSelector);
  timeInMillis = timeInMillis || getNDaysPriorStartTime(5).getTime();

  const newTime = new Date().getTime();
  const url = buildURL(API_ENDPOINTS.GET_ALL_NOTIFICATIONS_URL, { timeInMillis });
  const apiResponse = yield call(httpRequest.get, url);

  if (apiResponse.success) {
    const { context } = apiResponse || {};
    const { notifications } = context || {};
    const parsedNotifications = (notifications || []).map(parseDataObj);
    yield put(getAllNotificationsAction.Success({ notifications: parsedNotifications, time: newTime }));

    if (notifications && notifications.length) {
      const notificationObj = new SnackbarHandlerSchema(
        '',
        `${notifications.length} New Notifications Received`,
        SNACKBAR_VARIANTS.INFO,
      );
      yield put(publishErrorAction.Trigger(notificationObj));
      yield call(triggerAlarmSounds, parsedNotifications);
    }
  } else {
    yield put(getAllNotificationsAction.Failure());
  }

  yield put(getAllNotificationsAction.Loading(false));
}

function* markNotificationsAck(action) {
  yield put(acknowledgeNotificationAction.Loading(true));
  const deivceIMEI = action.payload;

  const url = buildURL(API_ENDPOINTS.MARK_ALL_NOTIFICATION_ACK_URL, {}, { imei: deivceIMEI || '' });
  const apiResponse = yield call(httpRequest.post, url);

  if (apiResponse.success) {
    const { context } = apiResponse || {};
    const { notifications } = context || {};
    const parsedNotifications = (notifications || []).map(parseDataObj);
    yield put(acknowledgeNotificationAction.Success(parsedNotifications));
  } else {
    yield put(acknowledgeNotificationAction.Failure());
  }

  yield put(acknowledgeNotificationAction.Loading(false));
}

function* deleteNotificationsSaga(action) {
  yield put(deleteNotificationAction.Loading(true));
  const deivceIMEI = action.payload;

  const url = buildURL(API_ENDPOINTS.DELETE_ALL_NOTIFICATION_URL, {}, { imei: deivceIMEI || '' });
  const apiResponse = yield call(httpRequest.post, url);

  if (apiResponse.success) {
    const { context } = apiResponse || {};
    const { notifications } = context || {};
    const parsedNotifications = (notifications || []).map(parseDataObj);
    yield put(deleteNotificationAction.Success(parsedNotifications));
  } else {
    yield put(deleteNotificationAction.Failure());
  }

  yield put(deleteNotificationAction.Loading(false));
}

export default function* notificationsSaga() {
  yield takeLatest(GET_ALL_NOTIFICATIONS_ACTIONTYPE.REQUEST, getAllNotificationForUser);
  yield takeLatest(MARK_NOTIFICATIONS_ACK_ACTIONTYPE.REQUEST, markNotificationsAck);
  yield takeLatest(DELETE_NOTIFICATIONS_ACTIONTYPE.REQUEST, deleteNotificationsSaga);
}
